/**
 * API Helper class for fetching & posting data
 */
export default class Api {
    constructor() {}

    /**
     * Get Data from endpoint
     * @param {*} endpoint
     * @param {*} params
     * @returns {*} json object
     */
    async fetchData(endpoint, params) {
        const url = params ? `${endpoint}?${new URLSearchParams(params)}` : endpoint;
        document.querySelector('.div-receiver-loader').style.display = 'block';

        let json = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        })
            .then((response) => {
                document.querySelector('.div-receiver-loader').style.display = 'none';
                return response.json().then((data) => ({
                    status: response.status,
                    body: data,
                }));
            })
            .catch((err) =>
                console.log(
                    'Request Failed',
                    typeof err === 'object' && err !== null ? ', Result is not an object' : err
                )
            );

        return json;
    }

    /**
     * Post data to endpoint
     * @param {*} endpoint
     * @param {*} payload
     * @returns {*} json object
     */
    async postData(endpoint, payload) {
        let json = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) =>
                response.json().then((data) => ({
                    status: response.status,
                    body: data,
                }))
            )
            .catch((error) => {
                console.log(error); // Handle the error response object
            });
        return json;
    }
}
